import React from 'react';
import { checkLetter, checkPuzzle, checkWord, revealPuzzle, revealLetter, revealWord, toggleAutoCheck, clearPuzzle } from '../archiveMorphologyUtils';
import { ArchiveMorphologyStore } from '../ArchiveMorphologyStore';
import CustomRevealConfirmationDialog from '../../shared/CustomRevealConfirmationDialog';

const RevealConfirmationDialogCluster = () => {
  const confirmationDialogSettings = ArchiveMorphologyStore.useState(s => s.toolbar.confirmationDialog);

  return (
    <>
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={clearPuzzle}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.clearAllIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.clearAllIsOpen}
        prompt="Are you sure you want to clear the entire puzzle?"
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={checkLetter}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.checkLetterIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.checkLetterIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={checkWord}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.checkWordIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.checkWordIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={checkPuzzle}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.checkPuzzleIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.checkPuzzleIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={toggleAutoCheck}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.autocheckIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.autocheckIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={revealLetter}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.revealLetterIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.revealLetterIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={revealWord}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.revealWordIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.revealWordIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArchiveMorphologyStore as any}
        onConfirm={revealPuzzle}
        onClose={() => {
          ArchiveMorphologyStore.update(s => {
            s.toolbar.confirmationDialog.revealAllIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.revealAllIsOpen}
        prompt="Are you sure you want to reveal the full puzzle? This puzzle will count as revealed and be excluded from any solve streak."
      />
    </>
  )
};

export default RevealConfirmationDialogCluster;